import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import {
  ANNOUNCEMENT_BANNER_COLORS,
  ANNOUNCEMENT_BANNER_DISMISSED_KEY,
  getAnnouncementBannerSessionValue,
  isAnnouncementBannerActive,
  normalizeAnnouncementBanner,
} from '../../../utils/announcementBannerUtils'

const AnnouncementBanner = ({ announcementBanner }) => {
  const [dismissedAnnouncementBanner, setDismissedAnnouncementBanner] =
    React.useState(() =>
      sessionStorage.getItem(ANNOUNCEMENT_BANNER_DISMISSED_KEY)
    )

  const normalizedBanner = React.useMemo(() => {
    return normalizeAnnouncementBanner(announcementBanner)
  }, [announcementBanner])

  const announcementBannerSessionValue = React.useMemo(() => {
    return getAnnouncementBannerSessionValue(announcementBanner)
  }, [announcementBanner])

  const showAnnouncementBanner =
    isAnnouncementBannerActive(announcementBanner) &&
    dismissedAnnouncementBanner !== announcementBannerSessionValue

  const closeAnnouncementBanner = React.useCallback(() => {
    sessionStorage.setItem(
      ANNOUNCEMENT_BANNER_DISMISSED_KEY,
      announcementBannerSessionValue
    )
    setDismissedAnnouncementBanner(announcementBannerSessionValue)
  }, [announcementBannerSessionValue])

  if (!showAnnouncementBanner || !normalizedBanner) {
    return null
  }

  const colors =
    ANNOUNCEMENT_BANNER_COLORS[normalizedBanner.color] ||
    ANNOUNCEMENT_BANNER_COLORS.green

  return (
    <div
      style={{
        background: colors.background,
        borderBottom: `1px solid ${colors.border}`,
        borderRadius: 0,
        padding: '16px 64px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '24px',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          paddingRight: '24px',
        }}
      >
        {normalizedBanner.title && (
          <div
            style={{
              color: colors.title,
              fontSize: '15px',
              fontWeight: 700,
              lineHeight: 1.4,
              marginBottom: normalizedBanner.message ? '4px' : 0,
            }}
          >
            {normalizedBanner.title}
          </div>
        )}

        {normalizedBanner.message && (
          <div
            style={{
              color: '#1f2937',
              fontSize: '15px',
              fontWeight: 500,
              lineHeight: 1.5,
              whiteSpace: 'pre-line',
            }}
          >
            {normalizedBanner.message}
          </div>
        )}
      </div>

      <IconButton
        size="small"
        onClick={closeAnnouncementBanner}
        style={{
          color: '#8a94a6',
          padding: '4px',
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </div>
  )
}

export default AnnouncementBanner